import { BrowserRouter, Routes, Route } from "react-router-dom";
// import Home from "./pages/Home";
import HomePage from "./pages/Home/HomePage";

//import Cart from "./pages/Cart";
import Cart from "./components/Cart/CartTabs";

// import Checkout from "./pages/Checkout";

import Checkout from "./components/Checkout/Checkout";

import Products from "./pages/Products";
import Product from "./pages/Product";
import Navbar from "./components/Navbar";
import { CartProvider } from "./context/CartContext";
import { WishlistProvider } from "./context/WishlistContext-plus";
import Wishlist from "./pages/Wishlist";
import { Toaster } from "react-hot-toast";
import Login from "./pages/Login";
import Register from "./pages/Register";
import { AuthProvider } from "./context/AuthContext";

import Orders from "./pages/Orders";

import Articles from "./pages/Articles/Articles";
import ProtectedRoute from "./routes/ProtectedRoute";
//import { SettingsProvider } from "./context/SettingsContext";
import PageBanner from "./components/PageBanner";

import DashboardLayout from "./components/Layout/DashboardLayout";
import DashboardProfile from "./components/DashboardProfile";
import DashboardWishlist from "./components/DashboardWishlist";
import DashboardVisitedProducts from "./components/DashboardVisitedProducts";
import DashboardComments from "./components/Dashboard/Comments/DashboardComments";
import DashboardAddresses from "./components/DashboardAddresses";
import DashboardOrders from "./components/DashboardOrders";
import FinancialReport from "./components/DashboardFinancialReport";
import OrderDetail from "./components/OrderDetail";
import ChangePassword from "./pages/ChangePassword";
import Prescription from "./pages/pharmacy/Prescription";
import PharmacyOrderDetails from "./pages/pharmacy/PharmacyOrderDetails";

import PrescriptionCart from "./pages/Dashboard/Pharmacy/PrescriptionCart";
//import PrescriptionCart from "./pages/pharmacy/PrescriptionCart";

import PrescriptionOrderDetails from "./pages/pharmacy/PrescriptionOrderDetails";
import PrescriptionOrders from "./pages/pharmacy/PrescriptionOrders";
import ArticleDetail from "./pages/Articles/ArticleDetail/ArticleDetail";
import ProductPage from "./pages/Product/ProductPage";
import MainLayout from "./layouts/MainLayout";

import Contents from "./pages/Contents/Contents";
import Faqs from "./pages/Faqs";
import Contact from "./pages/Contact";
import ScrollToTop from "./components/common/ScrollToTop/ScrollToTop";
import LoginPage from "./components/Auth/LoginPage";
import { Import } from "lucide-react";
import { PrescriptionCartProvider } from "./context/pharmacy/PrescriptionCartContext";

export default function App() {
  return (
    <AuthProvider>
      {/* <ThemeProvider> */}
      <WishlistProvider>
        <CartProvider>
          <BrowserRouter>
            <ScrollToTop />
            {/* <PageBanner /> */}
            <Toaster />

            {/* <Navbar /> */}

            {/* <SettingsProvider> */}
            <Routes>
              <Route element={<MainLayout />}>
                <Route path="/contents/:slug" element={<Contents />} />
                <Route path="/تماس-با-ما" element={<Contact />} />
                <Route path="/پرسشهای-متداول" element={<Faqs />} />
                <Route path="/مجله-سلامت" element={<Articles />} />
                <Route path="/articles/:slug" element={<ArticleDetail />} />

                {/* <Route path="/" element={<Home />} /> */}
                <Route path="/" element={<HomePage />} />
                <Route path="/cart" element={<Cart />} />
                {/* <Route path="/checkout" element={<Checkout />} /> */}
                <Route
                  path="/checkout"
                  element={
                    <ProtectedRoute>
                      <Checkout />
                    </ProtectedRoute>
                  }
                />

                <Route path="/product/:slug" element={<ProductPage />} />

                {/* <Route path="/product/:slug" element={<Product />} /> */}

                <Route path="/products" element={<Products />} />

                <Route path="/wishlist" element={<Wishlist />} />
                {/* <Route path="/login" element={<Login />} /> */}
                <Route path="/login" element={<LoginPage />} />

                <Route path="/register" element={<Register />} />

                <Route
                  path="/dashboard"
                  element={
                    <ProtectedRoute>
                      <DashboardLayout />
                    </ProtectedRoute>
                  }
                >
                  <Route path="orders" element={<DashboardOrders />} />
                  <Route
                    path="financial-report"
                    element={<FinancialReport />}
                  />

                  <Route
                    path="/dashboard/order-detail/:id"
                    element={<OrderDetail />}
                  />

                  <Route
                    path="pharmacy/prescription-cart"
                    element={<PrescriptionCart />}
                  />

                  <Route
                    path="pharmacy/prescription"
                    element={<Prescription />}
                  />

                  <Route
                    path="/dashboard/pharmacy/orders/:id"
                    element={<PharmacyOrderDetails />}
                  />

                  {/* <Route
                    path="pharmacy/prescription-cart"
                    element={<PrescriptionCart />}
                  /> */}

                  <Route
                    path="pharmacy/prescription-orders/:id"
                    element={<PrescriptionOrderDetails />}
                  />

                  {/* <Route
                    path="pharmacy/prescription-orders"
                    element={<PrescriptionOrders />}
                  /> */}

                  <Route path="profile" element={<DashboardProfile />} />

                  <Route path="address" element={<DashboardAddresses />} />

                  <Route path="wishlist" element={<DashboardWishlist />} />

                  <Route
                    path="visited-products"
                    element={<DashboardVisitedProducts />}
                  />
                  <Route path="comments" element={<DashboardComments />} />

                  <Route path="change-password" element={<ChangePassword />} />

                  <Route path="orders" element={<Orders />} />
                </Route>
              </Route>
            </Routes>
            {/* </SettingsProvider> */}
          </BrowserRouter>
        </CartProvider>
      </WishlistProvider>
      {/* </ThemeProvider> */}
    </AuthProvider>
  );
}
